module.exports = __webpack_public_path__ + "img/icon2.5d280843.png";